import { render } from "./CallQueuesGroups.vue?vue&type=template&id=286e8808"
import script from "./CallQueuesGroups.vue?vue&type=script&lang=js"
export * from "./CallQueuesGroups.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__